import React, { useEffect, useState } from "react";
import { Combobox, Toast } from "../..";
import { apis, get } from "../../../Utils/axios";

function PolicySearch({ onSelect = () => {}, type, placeholder = "Search Policies", label, selected = {}, className = "" }) {
	const [AllPolicies, setAllPolicies] = useState([]);
	const [Loader, setLoader] = useState();

	const fetchPolicies = (query = "") => {
		setLoader(true);
		const params = { page: 1 };
		if (query) {
			params.search = query;
		}

		get(type === "travel" ? apis.getTravelPolicies : apis.getExpensePolicies, params, (r, e) => {
			if (r) {
				setAllPolicies(r.policies);
				setLoader(false);
			} else if (e) {
				console.log(e);
				Toast.handleError(e);
				setLoader(false);
			}
		});
	};

	const onChange = (query) => {
		fetchPolicies(query);
	};

	useEffect(() => {
		// Preload policies so the dropdown shows options even before typing
		fetchPolicies("");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [type]);

	return (
		<>
			<Combobox
				loading={Loader}
				label={label}
				placeholder={placeholder}
				className={className}
				onChange={onChange}
				options={AllPolicies.map((policy) => ({
					...policy,
					label: policy.name,
					value: policy.id,
				}))}
				selected={selected}
				onSelect={onSelect}
			/>
		</>
	);
}

export default PolicySearch;
